import Axios from '../utils/axios-utils';


// get audit logs
export const getAuditLogs = async (accountId, linkedType, linkedId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/audit?linkedType=${linkedType}&linkedId=${linkedId}`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get Audit Logs error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get Audit Logs failed" }
        };
    }
};